import { gql } from "gql";
import { ProductOffersContext } from "gql/graphql";
import { getActiveUser } from "@noom/hive-auth";
import { apolloClient } from "src/api/apolloClient";

export const PRODUCT_OFFERS_QUERY = gql(`
  query ProductOffers($input: ProductOffersInput!) {
    productOffers(input: $input) {
      offers {
        productName
        purchaseType
        orderOperation {
          ... on PurchaseOperation {
            saleItemId
            trialSaleItemId
            discountSummary {
              discounts {
                promoCode
                b2bConsumerDiscountId
                discountEffect {
                  ... on OrderPercentageDiscount {
                    percentage
                  }
                  ... on OrderFixedDiscount {
                    percentageDiscountConvertedToFixed
                    amount {
                      currencyCode
                      units
                      nanos
                    }
                  }
                }
              }
            }
          }
          ... on SwitchOperation {
            saleItemId
            trialSaleItemId
            discountSummary {
              discounts {
                promoCode
                b2bConsumerDiscountId
                discountEffect {
                  ... on OrderPercentageDiscount {
                    percentage
                  }
                  ... on OrderFixedDiscount {
                    percentageDiscountConvertedToFixed
                    amount {
                      currencyCode
                      units
                      nanos
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export async function getProductOffers(context?: ProductOffersContext) {
  const accessCode = getActiveUser()?.accessCode;

  const result = await apolloClient.query({
    query: PRODUCT_OFFERS_QUERY,
    variables: {
      input: { accessCode, context },
    },
    fetchPolicy: "no-cache",
  });

  return result.data.productOffers;
}
